import Vue from 'vue';
import Vuetify from 'vuetify';

import de from 'vuetify/src/locale/de'
import 'vuetify/dist/vuetify.css';
import '../vuetify.scss';
import '../styles.scss';

Vue.use(Vuetify);

export default new Vuetify({
    dark: true,
    options: {
        customProperties: true,
    },
    theme: {
        dark: true,
    },
    /*
    themes: {
      light: {
        primary: '#02c9d8',
        secondary: '#FEBD00',
        accent: '#00C7C7',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FF9800',
      },
      dark: {
        primary: '#02c9d8',
        secondary: '#FEBD00',
        accent: '#00C7C7',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FF9800',
      },
    },
},
   */
    lang: {
        locales: { de },
        current: 'de',
    },
});

console.log("init vuetify")

